import { ObjectIconFilter } from './object-icon.filter'; 
import { ContentTextFilter } from './content-text.filter'; 
import { ScheduleMeeting } from './schedule-meeting.filter'; 
import { MomentDate } from './moment-date.filter'; 

export const ContentFilters = {
  ObjectIconFilter,
  ContentTextFilter,
  ScheduleMeeting,
  MomentDate
};